<orbit-dialog-header [title]="data.title" />

<div class="dialog-content">
  <form [formGroup]="data.form" class="language-form">
    <div class="form-group">
      <label for="headerColor">{{ 'SETTINGS.GENERAL.COLORS.HEADER_COLOR' | translate }}</label>
      <input
        formControlName="headerColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['headerColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="data.form.controls['headerColor'].setValue($event)"
        [style.background]="data.form.controls['headerColor'].value" />
      @if (data.form?.controls['headerColor'].invalid) {
        <div class="error-message">
          {{ 'SETTINGS.GENERAL.LANGUAGE_REQUIRED' | translate }}
        </div>
      }
    </div>

    <div class="form-group">
      <label for="buttonColor">{{ 'SETTINGS.GENERAL.COLORS.BUTTON_COLOR' | translate }}</label>
      <input
        formControlName="buttonColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['buttonColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="data.form.controls['buttonColor'].setValue($event)"
        [style.background]="data.form.controls['buttonColor'].value" />
    </div>

    <div class="form-group">
      <label for="buttonHoverColor">
        {{ 'SETTINGS.GENERAL.COLORS.BUTTON_HOVER_COLOR' | translate }}
        {{ data.form.controls['buttonHoverColor'].value }}
      </label>
      <input
        formControlName="buttonHoverColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['buttonHoverColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="data.form.controls['buttonHoverColor'].setValue($event)"
        [style.background]="data.form.controls['buttonHoverColor'].value" />
    </div>

    <div class="form-group">
      <label for="buttonLabelColor">
        {{ 'SETTINGS.GENERAL.COLORS.BUTTON_LABEL_COLOR' | translate }}
      </label>
      <input
        formControlName="buttonLabelColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['buttonLabelColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="data.form.controls['buttonLabelColor'].setValue($event)"
        [style.background]="data.form.controls['buttonLabelColor'].value" />
    </div>

    <div class="form-group">
      <label for="clientButtonColor">
        {{ 'SETTINGS.GENERAL.COLORS.CLIENT_BUTTON_COLOR' | translate }}
      </label>
      <input
        formControlName="clientButtonColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['clientButtonColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="data.form.controls['clientButtonColor'].setValue($event)"
        [style.background]="data.form.controls['clientButtonColor'].value" />
    </div>

    <div class="form-group">
      <label for="clientButtonHoverColor">
        {{ 'SETTINGS.GENERAL.COLORS.CLIENT_BUTTON_HOVER_COLOR' | translate }}
      </label>
      <input
        formControlName="clientButtonHoverColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['clientButtonHoverColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="data.form.controls['clientButtonHoverColor'].setValue($event)"
        [style.background]="data.form.controls['clientButtonHoverColor'].value" />
    </div>

    <div class="form-group">
      <label for="clientButtonLabelColor">
        {{ 'SETTINGS.GENERAL.COLORS.CLIENT_BUTTON_LABEL_COLOR' | translate }}
      </label>
      <input
        formControlName="clientButtonLabelColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['clientButtonLabelColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="data.form.controls['clientButtonLabelColor'].setValue($event)"
        [style.background]="data.form.controls['clientButtonLabelColor'].value" />
    </div>

    <div class="form-group">
      <label for="senderChatBubbleColor">
        {{ 'SETTINGS.GENERAL.COLORS.SENDER_CHAT_BUBBLE_COLOR' | translate }}
      </label>
      <input
        formControlName="senderChatBubbleColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['senderChatBubbleColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="data.form.controls['senderChatBubbleColor'].setValue($event)"
        [style.background]="data.form.controls['senderChatBubbleColor'].value" />
    </div>

    <div class="form-group">
      <label for="participantChatBubbleColor">
        {{ 'SETTINGS.GENERAL.COLORS.PARTICIPANT_CHAT_BUBBLE_COLOR' | translate }}
      </label>
      <input
        formControlName="participantChatBubbleColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['participantChatBubbleColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="data.form.controls['participantChatBubbleColor'].setValue($event)"
        [style.background]="data.form.controls['participantChatBubbleColor'].value" />
    </div>

    <div class="form-group">
      <label for="senderChatBubbleTextColor">
        {{ 'SETTINGS.GENERAL.COLORS.SENDER_CHAT_BUBBLE_TEXT_COLOR' | translate }}
      </label>
      <input
        formControlName="senderChatBubbleTextColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['senderChatBubbleTextColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="data.form.controls['senderChatBubbleTextColor'].setValue($event)"
        [style.background]="data.form.controls['senderChatBubbleTextColor'].value" />
    </div>

    <div class="form-group">
      <label for="participantChatBubbleTextColor">
        {{ 'SETTINGS.GENERAL.COLORS.PARTICIPANT_CHAT_BUBBLE_TEXT_COLOR' | translate }}
      </label>
      <input
        formControlName="participantChatBubbleTextColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['participantChatBubbleTextColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="data.form.controls['participantChatBubbleTextColor'].setValue($event)"
        [style.background]="data.form.controls['participantChatBubbleTextColor'].value" />
    </div>

    <div class="form-group">
      <label for="clientSenderChatBubbleColor">
        {{ 'SETTINGS.GENERAL.COLORS.CLIENT_SENDER_CHAT_BUBBLE_COLOR' | translate }}
      </label>
      <input
        formControlName="clientSenderChatBubbleColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['clientSenderChatBubbleColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="data.form.controls['clientSenderChatBubbleColor'].setValue($event)"
        [style.background]="data.form.controls['clientSenderChatBubbleColor'].value" />
    </div>

    <div class="form-group">
      <label for="clientParticipantChatBubbleColor">
        {{ 'SETTINGS.GENERAL.COLORS.CLIENT_PARTICIPANT_CHAT_BUBBLE_COLOR' | translate }}
      </label>
      <input
        formControlName="clientParticipantChatBubbleColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['clientParticipantChatBubbleColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="
          data.form.controls['clientParticipantChatBubbleColor'].setValue($event)
        "
        [style.background]="data.form.controls['clientParticipantChatBubbleColor'].value" />
    </div>

    <div class="form-group">
      <label for="clientSenderChatBubbleTextColor">
        {{ 'SETTINGS.GENERAL.COLORS.CLIENT_SENDER_CHAT_BUBBLE_TEXT_COLOR' | translate }}
      </label>
      <input
        formControlName="clientSenderChatBubbleTextColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['clientSenderChatBubbleTextColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="data.form.controls['clientSenderChatBubbleTextColor'].setValue($event)"
        [style.background]="data.form.controls['clientSenderChatBubbleTextColor'].value" />
    </div>

    <div class="form-group">
      <label for="clientParticipantChatBubbleTextColor">
        {{ 'SETTINGS.GENERAL.COLORS.CLIENT_PARTICIPANT_CHAT_BUBBLE_TEXT_COLOR' | translate }}
      </label>
      <input
        formControlName="clientParticipantChatBubbleTextColor"
        class="color-picker-input"
        [(colorPicker)]="data.form.controls['clientParticipantChatBubbleTextColor'].value"
        [cpOutputFormat]="'hex'"
        [cpAlphaChannel]="'forced'"
        (colorPickerChange)="
          data.form.controls['clientParticipantChatBubbleTextColor'].setValue($event)
        "
        [style.background]="data.form.controls['clientParticipantChatBubbleTextColor'].value" />
    </div>
  </form>
</div>

<orbit-dialog-footer>
  <div class="right-addon" right-addon>
    <orbit-button
      [flat]="true"
      [disabled]="false"
      [label]="data.cancelLabel"
      (onClick)="closeDialog(false)"></orbit-button>
    <orbit-button
      [disabled]="data.form.invalid"
      [label]="data.confirmLabel"
      (onClick)="closeDialog(true)"></orbit-button>
  </div>
</orbit-dialog-footer>
